import { FormattedMessage } from 'react-intl';

import { Card } from '@shieldpay/bumblebee/card';
import { Heading } from '@shieldpay/bumblebee/heading';
import { Column } from '@shieldpay/bumblebee/layout';

import { Link } from '@shieldpay/utilities-ui/link';

import { CONTENT_IDS } from '~/components/contents-table/utils';

export const ContentsTable = () => {
  return (
    <Column alignContent={{ x: 'left' }}>
      <Card alignContent={{ x: 'left' }} spacing={'basePos3'}>
        <Heading level="2" variant="captionMedium150">
          <FormattedMessage id="hive.titles.contents" />
        </Heading>
        <Link to={`#${CONTENT_IDS.LIVE_DEMO}`}>
          <FormattedMessage id="hive.titles.liveDemo" />
        </Link>
        <Link to={`#${CONTENT_IDS.DESIGN}`}>
          <FormattedMessage id="hive.titles.design" />
        </Link>
        <Link to={`#${CONTENT_IDS.CODE}`}>
          <FormattedMessage id="hive.titles.code" />
        </Link>
      </Card>
    </Column>
  );
};
